import {useFetch} from "../useFetch";
import {LoadTypes} from "../../types/api/guide/loadType.types";
import {loadTypeService} from "../../services/guide/loadType-service";

export const useFetchGetLoadTypeById = (id?: string) => {

    const { isLoading, error, data } =
        useFetch<LoadTypes>(
            loadTypeService.getById,
            [id],
            { enabled: Boolean(id) });

    return { data: data as LoadTypes, isLoading, error };
}